import $ from 'jquery';
import $script from 'scriptjs';

export default class StaticGiftCard {
  constructor() {
    const scripts = document.querySelector('[data-scripts]');
    $script([scripts.dataset.qrcodeJsUrl], () => this.addQrCode());
  }

  addQrCode() {
    const qrWrapper = $('[data-qr-code]');

    this.QRCode = new window.QRCode(qrWrapper[0], {
      text: qrWrapper.data('qr-code'),
      width: 120,
      height: 120,
    });
  }
}
